/**
 * Display helpers for `GET /api/v1/kyb/status` (slim SessionPayload).
 * Do not render verifications, documents, or webhook bodies in the user app.
 */

export function kybDisplayDash(value) {
  const s = value == null ? "" : String(value).trim();
  return s || "—";
}

export function pickKybBusinessName(payload) {
  return kybDisplayDash(
    payload?.legal_name
      || payload?.legalName
      || payload?.businessName
      || payload?.companyName
      || payload?.registeredCompanyName
  );
}

export function pickKybApplicationId(payload) {
  return kybDisplayDash(
    payload?.application_id
      || payload?.applicationId
      || payload?.session_id
      || payload?.sessionId
      || payload?.verificationSessionId
  );
}

/** `May 21, 2025 • 10:30 AM (UTC)` from `verified_at` / `updated_at`. */
export function formatKybVerifiedAtUtc(payload) {
  const raw =
    payload?.verified_at
    || payload?.verifiedAt
    || payload?.updated_at
    || payload?.updatedAt;
  if (raw == null || raw === "") return "—";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "—";
  const date = d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
  const time = d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC",
  });
  return `${date} • ${time} (UTC)`;
}
